/*
 * @Author: YuanYuan
 * @Date: 2025-12-08 18:39:10
 * @LastEditTime: 2026-01-26 17:41:50
 * @Description: 
 */
import i18n from '@/i18n'

export default [
  {
    name: 'RouteOptions',
    value: [
      { label: i18n.t('common.chinaMainland'), value: 1, disabled: true }, // 中国大陆
      { label: i18n.t('purchase.globalNoMainland'), value: 2, desc: i18n.t('purchase.globalNoMainlandDesc') }, // 全球（不包含中国大陆）
      { label: i18n.t('common.global'), value: 3, disabled: true } // 全球（包含中国大陆）
    ]
  },
  {
    name: 'SubRouteOptions',
    value: [
      { label: i18n.t('purchase.highPerfHK'), value: 4, desc: i18n.t('purchase.highPerfHKDesc') } // 高性能链路（大陆-香港）
    ]
  },
  {
    name: 'BuyTimeUnitOptions',
    value: [
      { label: i18n.t('common.days'), value: 0 }, // 天
      { label: i18n.t('common.countMonths'), value: 1 }, // 个月
      { label: i18n.t('common.countYears'), value: 2 } // 年
    ]
  },
  {
    name: 'CsBuyDurationOptions',
    value: [
      { label: i18n.t('common.oneMonth'), value: 1 },
      { label: 2 + i18n.t('common.severalMonths'), value: 2 },
      { label: 3 + i18n.t('common.severalMonths'), value: 3 },
      { label: 4 + i18n.t('common.severalMonths'), value: 4 },
      { label: 5 + i18n.t('common.severalMonths'), value: 5 },
      { label: 6 + i18n.t('common.severalMonths'), value: 6 },
      { label: i18n.t('common.oneYear'), value: 12 },
      { label: 2 + i18n.t('common.severalYears'), value: 24 },
      { label: 3 + i18n.t('common.severalYears'), value: 36 }
    ]
  }
]
